export enum StageName {
  Personal = 'personal',
  Dev = 'dev',
  Beta = 'beta',
  Gamma = 'gamma',
  Prod = 'prod',
}

export function getStageName(): StageName {
  const href = window.location.href;

  if (href.includes('localhost')) {
    return StageName.Personal;
  }

  // Check for stage-specific domains first (more specific matches)
  // IMPORTANT: Check beta/gamma/prod subdomains before the base domain check
  if (href.includes('beta.')) {
    return StageName.Beta;
  }
  
  if (href.includes('gamma.')) {
    return StageName.Gamma;
  }
  
  if (href.includes('prod.')) {
    return StageName.Prod;
  }

  // Production uses the base domain without subdomain
  // Check for base domain (no subdomain) = Production
  if (href.includes('control-navigator.gss.aws.dev') && 
      !href.includes('beta.') && 
      !href.includes('gamma.') && 
      !href.includes('prod.')) {
    return StageName.Prod;
  }

  // Check for specific Production CloudFront distribution BEFORE generic check
  if (href.includes('d27hk928kgsydk.cloudfront.net')) {
    return StageName.Prod;
  }

  // Check for CloudFront distribution patterns (other distributions are Dev)
  // Dev environment uses CloudFront distribution
  if (href.includes('cloudfront.net')) {
    return StageName.Dev;
  }

  // Default to dev for unknown environments
  return StageName.Dev;
}

export function getRegion(): string {
  // Default to us-west-2 for now
  return 'us-west-2';
}

export function getPartition(): string {
  return 'aws';
}
